/**
 * Recently Viewed Product Tracker
 * Automatically saves current product to recently viewed when on product page
 */

class RecentlyViewedTracker {
  constructor() {
    this.init();
  }

  init() {
    // Check if we're on a product page
    if (this.isProductPage()) {
      const productHandle = this.getCurrentProductHandle();

      if (productHandle) {
        this.saveProduct(productHandle);
      }
    }
  }

  isProductPage() {
    // Check if we're on a product page by looking for product data
    return (
      document.body.classList.contains("template-product") ||
      window.location.pathname.includes("/products/")
    );
  }

  getCurrentProductHandle() {
    // Try to get product handle from URL
    const urlMatch = window.location.pathname.match(/\/products\/([^\/\?]+)/);
    if (urlMatch && urlMatch[1]) {
      return urlMatch[1];
    }

    // Fallback: try to get from meta tag if available
    const metaProduct = document.querySelector('meta[property="og:url"]');
    if (metaProduct) {
      const contentMatch = metaProduct.content.match(/\/products\/([^\/\?]+)/);
      if (contentMatch && contentMatch[1]) {
        return contentMatch[1];
      }
    }

    return null;
  }

  saveProduct(handle) {
    if (typeof RecentlyViewed !== "undefined") {
      RecentlyViewed.save(handle);
    } else {
      console.warn(
        "RecentlyViewed not available. Make sure globals.js is loaded."
      );
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    new RecentlyViewedTracker();
  });
} else {
  new RecentlyViewedTracker();
}
